<template>
  <div class="page">
    <div ref="h_top">
      <van-nav-bar title="我的座位" left-text="返回" left-arrow @click-left="back" class="bg-gradual-blue"></van-nav-bar>
      <van-dropdown-menu>
        <van-dropdown-item @change="initQuery" v-model="value1" :options="option1" />
        <van-dropdown-item @change="initQuery" v-model="value2" :options="option2" />
      </van-dropdown-menu>
    </div>

    <div ref="h_cont" style="margin:0 5px;overflow-y: auto;">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadList">
        <div style="margin-top: 5px;background-color: #FFFFFF;padding: 10px;border-radius: 5px;" v-for="item in list">
          <van-row>
            <van-col span="8">
              <van-cell title="预约时间" icon="clock-o" />
            </van-col>
            <van-col span="16">
              <van-cell>{{item.reserveDate}} {{item.statTime}}~{{item.endTime}}</van-cell>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="8">
              <van-cell title="预约位置" icon="location-o" />
            </van-col>
            <van-col span="16">
              <van-cell>{{item.roomName}} {{item.seatNo}}</van-cell>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="8">
              <van-cell title="预约状态" icon="info-o" />
            </van-col>
            <van-col span="16">
              <van-cell>{{item.operatingTypeName}}</van-cell>
            </van-col>
          </van-row>

          <div v-if="item.operatingType == 1 || item.operatingType == 2" style="text-align: right;">
            <!-- <van-button v-if="item.operatingType == 1" type="primary" size="small" @click="seatIntf(item)">入座</van-button> -->
            &nbsp;
            <van-button v-if="item.operatingType == 2" type="primary" size="small" @click="seatIntf(item)">离座</van-button>
            &nbsp;
            <van-button v-if="item.operatingType == 1" type="primary" size="small" @click="cancelSeat(item)">取消</van-button>
          </div>

        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
  import { loadData , showToast , hideToast } from '@/utils/common'
  import { Dialog } from 'vant';

  export default {
    components: { Dialog  },
    data() {
      return {
        value1: '1',
        value2: '',
        option1: [
          { text: '全部', value: '' },
          { text: '当前', value: '1' },
          { text: '历史', value: '2' },
        ],
        option2: [
          { text: '全部状态', value: '' },
          { text: '预约成功', value: '1' },
          { text: '已就坐', value: '2' },
          { text: '已取消', value: '3' },
          { text: '已失效', value: '4' },
          { text: '已结束', value: '6' }
        ],
        loading:false,
        finished:false,
        list:[],
        start:1,
        limit:10,
        isQuery:false
      }
    },
    mounted() {
      this.initScreenH();
    },
    methods: {
      initScreenH(){
        let fh = document.documentElement.clientHeight;
        let th = this.$refs.h_top.offsetHeight;
        this.$refs.h_cont.style.height = (fh - th)+'px';
      },
      initQuery(){
        this.list = [];
        this.start = 1;
        this.finished = false;
        this.loadList();
      },
      back() {
        history.back();
      },
      loadList(){
        if(this.isQuery){
          return;
        }
        this.isQuery = true;
        var paramsJson = {
          "userId": sessionStorage.getItem('login_userid'),
          "start": this.start,
          "limit": this.limit,
          "queryType": this.value1,
          "operatingType": this.value2
        }
		showToast();
        loadData('/appSeat/queryMyPage',paramsJson).then(response => {
          if(response && response.code == 0){
            let tList = response.data.list;
            for(let i = 0;i < tList.length;i++){
              this.list.push(tList[i]);
            }
            this.start = response.data.nextPage;
            this.finished = response.data.isLastPage;
            this.loading = false;
          }
          this.isQuery = false;
		  hideToast();
        }).catch(() => {
          this.isQuery = false;
		  hideToast();
        })
      },
      cancelSeat(row) {
        Dialog.confirm({
          message: '确认取消该预约吗？',
        }).then(() => {
          let param = {
            'id': row.reservedRecordId
          };
          loadData('/appSeat/cancel',param).then(response => {
            if(response && response.code == 0){
              row.operatingType = 3;
              row.operatingTypeName = '已取消';
            }else{
              Toast(response.message);
            }
          }).catch(() => {
            //this.listLoading = false
          })
        }).catch(() => {
          //alert(2);
        });
      },
      seatIntf: function (row,isback) {
        let paramsJson = {
          "userCard": sessionStorage.getItem('login_usercard'),
          "deviceType": 'ibeacon',                                    //app设备类型，ibeacon或wifi或者mix
          "dvModel": 'web',                //手机设备型号
          "sysVersion": 'web',            //系统版本
          "operType": 'click',                                 //操作类型  click（点击） 或者 scan （扫码）
          "imei": '',
          "reback": isback,                                           //操作类型  空 或者  reback （回坐）
          "seatId": row.seatId,
          "bssid": '',                                         //用户手机连接的wifi 的mac地址 和 ibeacon主从号
          "phoneSystem": '',                                      //手机操作系统'android', 'wifi'，android情况下，bssid 存储的也是wifi的mac地址
          "mixBssid": '',                             //deviceType = mix时，存储wifi的bssid
          "appVersion": 1.0,
          "version": '999.9.9',
          "tversion": '',
          "md5username": '',
          "reservedId": row.reservedRecordId + '',
          "etag": ''
        };
        loadData('/appSeat/scanSeat',paramsJson).then(response => {
          if(response && response.code == 0){
            if(row.operatingType == '1'){
              row.operatingType = 2;
              row.operatingTypeName = '已入座';
            }else if(row.operatingType == '2'){
              row.operatingType = 6;
              row.operatingTypeName = '已结束';
            }
          }else{
            Toast(response.message);
          }
        }).catch(() => {
          //this.listLoading = false
        })
      }
    }
  };
</script>

<style lang="less" scoped>
.logout {
  bottom: 0;
  height: 50px;
  color: #ff5f16;
}
</style>

